/* ===========================================================================
   HN · barra d'acquisto fissa in pagina prodotto — dal 2026-10-05
   ---------------------------------------------------------------------------
   Al posto di Zoorix Sticky ATC (spento il 2026-10-05). Foto, nome, la
   combinazione scelta, il prezzo e un bottone: compare quando il bottone del
   tema è uscito dallo schermo.

   ⚠️ Un solo bottone d'acquisto alla volta (merchant, 2026-10-05: «non deve
   confondere il cliente quando vede il fbt»). La barra SPARISCE mentre sullo
   schermo c'è un blocco che vende altro: «Molti clienti aggiungono anche»
   (blocco A, [data-hn-pdp="cross"]) e «Acquistati spesso insieme» / «Risparmia
   prendendo il Kit» (blocco B, [data-hn-pdp="pack"]). Sparisce anche col
   carrello o l'anteprima aperti, sul piè di pagina e se la variante è esaurita.

   ⚠️ Al tocco CLICCA IL BOTTONE VERO del tema: l'aggiunta passa dalla stessa
   strada (tema pronto: theme.js → /cart/add.js → il carrello si apre; tema non
   ancora pronto: l'invio lo prende snippets/hn-atc-guard.liquid). Nessuna
   seconda copia della logica d'acquisto.

   ⚠️ Niente IntersectionObserver: un salto di scorrimento (ancora, ritorno con
   «indietro», fling) non produce callback e la barra restava ferma (lezione
   della landing, test L24). Si misura la geometria vera a ogni frame utile.

   Il motivo per cui è nascosta sta in data-hn-bb-why (?hnbbdebug=1 lo stampa).
   =========================================================================== */
(function () {
  'use strict';
  var DEBUG = /[?&]hnbbdebug=1(&|$)/.test(window.location.search || '');
  var S = null, raf = 0, chT = 0;

  function q(sel, root) { return (root || document).querySelector(sel); }
  function vh() { return window.innerHeight || document.documentElement.clientHeight; }
  // «sullo schermo»: il viewport intero, così la barra scivola via appena compare il titolo del blocco
  function inView(el) {
    if (!el) return false;
    var r = el.getBoundingClientRect();
    return r.height > 0 && r.bottom > 0 && r.top < vh();
  }
  function design() { return !!(window.Shopify && window.Shopify.designMode); }
  function push(ev) {
    if (design()) return;
    try {
      window.dataLayer = window.dataLayer || [];
      window.dataLayer.push({ event: ev, hn_bb_pid: String(S.pid), hn_bb_vid: String(S.vid || ''), hn_bb_vp: isDesk() ? 'd' : 'm' });
    } catch (e) { /* niente */ }
  }
  function isDesk() {
    // il breakpoint lo decide il CSS (--hn-bb-desk), non una seconda copia qui
    try { return getComputedStyle(S.root).getPropertyValue('--hn-bb-desk').trim() === '1'; } catch (e) { return false; }
  }

  function find() {
    S.form = document.getElementById('product-form-' + S.pid);
    S.btn = (S.form && S.form.querySelector('[data-btn-addtocart]')) || document.getElementById('product-add-to-cart');
    S.input = S.form && S.form.querySelector('[name="id"]');
    if (S.btn && S.btn !== S.watched) {
      S.watched = S.btn;
      if (S.moBtn) S.moBtn.disconnect();
      S.moBtn = new MutationObserver(onBtn);
      S.moBtn.observe(S.btn, { attributes: true, attributeFilter: ['disabled', 'class'], childList: true, characterData: true, subtree: true });
    }
  }
  function curVid() { return S.input ? String(S.input.value) : ''; }

  function reason() {
    if (!S.btn || !document.documentElement.contains(S.btn)) find();
    if (!S.cfg || !S.btn) return 'nobtn';
    var v = S.cfg.vs && S.cfg.vs[curVid()];
    if (S.btn.disabled || /\bis-(soldout|notify-me)\b/.test(S.btn.className) || !v || !v.a) return 'soldout';
    if (S.cfg.desk === false && isDesk()) return 'desk';
    var hc = document.getElementById('hn-cart');
    if ((window.HNCart && window.HNCart.state && window.HNCart.state.open) || (hc && /\bis-(mounted|open)\b/.test(hc.className))) return 'cart';
    if (q('.hn-pdp-qv.is-open')) return 'qv';
    if (document.body.style.position === 'fixed') return 'lock';
    if (S.btn.getBoundingClientRect().bottom >= 0) return 'top';
    if (inView(q('[data-hn-pdp="cross"]'))) return 'a';
    if (inView(q('[data-hn-pdp="pack"]'))) return 'b';
    if (inView(q('.wrapper-footer') || q('footer'))) return 'foot';
    return 'ok';
  }

  function evaluate() {
    raf = 0;
    if (!S) return;
    // la foto si scarica solo quando la barra sta per servire: chi non scorre non paga niente
    if (!S.imgOn && S.btn && S.btn.getBoundingClientRect().top < 0) { S.imgOn = true; setImg(); }
    var why = reason();
    S.why = why;
    S.root.setAttribute('data-hn-bb-why', why);
    var vis = why === 'ok';
    if (vis !== S.visible) {
      S.visible = vis;
      if (vis) sync();
      S.root.classList.toggle('is-visible', vis);
      if (vis && !S.viewed) { S.viewed = true; push('hn_buybar_view'); }
    }
    if (DEBUG) debug();
  }
  function schedule() { if (S && !raf) raf = requestAnimationFrame(evaluate); }

  function setImg() {
    var v = S.cfg.vs[curVid()];
    var src = (v && v.i) || '';
    if (!src) { S.img.hidden = true; return; }
    if (S.img.getAttribute('src') !== src) S.img.setAttribute('src', src);
    S.img.hidden = false;
  }

  function sync() {
    if (!S) return;
    var vid = curVid(), v = S.cfg.vs[vid];
    S.vid = vid;
    if (v) {
      S.now.textContent = v.p;
      S.was.textContent = v.c || '-';
      S.was.hidden = !v.c;
    }
    var lab = '';
    // il set coi saponi scelti dal cliente (assets/hn-bys.js): la barra dice quelli
    var bys = window.HNBys && window.HNBys.label ? window.HNBys.label(S.pid) : '';
    if (bys) lab = bys;
    else if (S.cfg.multi) {
      // i tondini (hn-swatch) dicono già cosa c'è nella combinazione: la stessa frase
      var sw = q('.hn-sw[data-hn-sw="' + S.pid + '"]');
      var val = sw && sw.getAttribute('data-hn-sw-why') === 'ok' ? q('[data-hn-sw-val]', sw) : null;
      lab = val ? val.textContent.replace(/\s+/g, ' ').trim() : '';
      if (!lab && v && window.HNSwatch && window.HNSwatch.label) lab = window.HNSwatch.label(v.t);
    }
    S.lab.textContent = lab || '-';
    S.lab.hidden = !lab;
    var t = S.btn ? (S.btn.textContent || '').replace(/\s+/g, ' ').trim() : '';
    if (t) S.label.textContent = t;
    if (S.imgOn) setImg();
    busy();
  }

  function busy() {
    var on = !!(S.pending || (S.btn && /\bis-loading\b/.test(S.btn.className)));
    S.add.classList.toggle('is-loading', on);
    S.add.setAttribute('aria-busy', on ? 'true' : 'false');
  }
  function onBtn() { sync(); schedule(); }

  /* ------------------------------------------------------------- aggiunta */
  function endPending() {
    if (!S.pending) return;
    S.pending = false;
    clearTimeout(S.capT); clearTimeout(S.idleT);
    busy();
  }
  function idle() {
    // il tema toglie .is-loading prima della fine dell'aggiunta: si aspetta almeno 1,5 s
    if (!S.pending) return;
    if (S.btn && /\bis-loading\b/.test(S.btn.className)) { S.idleT = setTimeout(idle, 400); return; }
    endPending();
  }
  function success() {
    if (!S.awaiting) return;
    S.awaiting = false;
    endPending();
    // nell'ordine resta che la barra è stata usata: per hn_add_to_cart un'aggiunta
    // dalla barra è identica a una dal bottone del tema
    try {
      var R = window.HNCart && window.HNCart.reco;
      if (!R || !R.setAttribute) return;
      var c = R.cart, m = /^1;a:(\d+)/.exec((c && c.attributes && c.attributes.hn_bb) || '');
      var n = Math.max(m ? +m[1] : 0, S.written || 0) + 1;
      S.written = n;
      R.setAttribute('hn_bb', '1;a:' + n);
    } catch (e) { /* niente */ }
  }
  function onAdd(ev) {
    ev.preventDefault();
    if (S.pending) return;
    if (!S.btn || S.btn.disabled) { schedule(); return; }
    S.pending = true; S.awaiting = true;
    busy();
    push('hn_buybar_add');
    S.capT = setTimeout(function () { S.awaiting = false; endPending(); }, 8000);
    S.idleT = setTimeout(idle, 1500);
    // il bottone VERO: con il tema pronto lo gestisce theme.js, prima la guardia
    S.btn.click();
  }

  /* ------------------------------------------------- tocco su foto e nome */
  function onBack(ev) {
    ev.preventDefault();
    var t = q('.hn-sw[data-hn-sw="' + S.pid + '"]:not([hidden])') ||
      q('variant-radios[data-product="' + S.pid + '"]') || q('variant-selects[data-product="' + S.pid + '"]') ||
      document.getElementById('product-price-' + S.pid) || q('.productView-title') || S.form;
    if (!t) return;
    var calm = false;
    try { calm = window.matchMedia('(prefers-reduced-motion: reduce)').matches; } catch (e) { /* niente */ }
    try { t.scrollIntoView({ block: 'center', behavior: calm ? 'auto' : 'smooth' }); } catch (e) { t.scrollIntoView(); }
    push('hn_buybar_back');
  }

  /* --------------------------------------------------------- osservatori */
  function watchCart() {
    var hc = document.getElementById('hn-cart');
    if (!hc || hc === S.cartEl) return;
    S.cartEl = hc;
    new MutationObserver(function () {
      if (/\bis-(mounted|open)\b/.test(hc.className)) success();
      schedule();
    }).observe(hc, { attributes: true, attributeFilter: ['class'] });
  }
  function watchQv(node) {
    if (!node || node.__hnBb) return;
    node.__hnBb = true;
    new MutationObserver(schedule).observe(node, { attributes: true, attributeFilter: ['class'] });
  }
  function onBody(muts) {
    for (var i = 0; i < muts.length; i++) {
      var add = muts[i].addedNodes || [];
      for (var j = 0; j < add.length; j++) {
        var n = add[j];
        if (n.nodeType === 1 && n.classList.contains('hn-pdp-qv')) watchQv(n);
        if (n.nodeType === 1 && n.id === 'hn-cart') watchCart();
      }
    }
    schedule();
  }

  function debug() {
    var box = document.getElementById('hn-bb-dbg');
    if (!box) {
      box = document.createElement('pre');
      box.id = 'hn-bb-dbg';
      box.style.cssText = 'position:fixed;top:0;left:0;z-index:2147483001;margin:0;padding:6px 8px;max-width:90vw;font:11px/1.35 monospace;background:rgba(255,255,255,.94);color:#111;border:1px solid #999;white-space:pre-wrap;pointer-events:none';
      document.body.appendChild(box);
    }
    var r = function (el) { if (!el) return '—'; var b = el.getBoundingClientRect(); return Math.round(b.top) + '→' + Math.round(b.bottom); };
    box.textContent = 'hn-buybar: ' + S.why + (S.visible ? ' (visibile)' : '') +
      '\nvariante ' + curVid() + '  desktop ' + isDesk() +
      '\nbottone ' + r(S.btn) + '  A ' + r(q('[data-hn-pdp="cross"]')) + '  B ' + r(q('[data-hn-pdp="pack"]')) +
      '  piè ' + r(q('.wrapper-footer') || q('footer')) + '  schermo ' + vh();
  }

  /* ------------------------------------------------------------- avvio */
  function mount() {
    var all = document.querySelectorAll('[data-hn-bb]');
    if (!all.length) return;
    var root = all[0];
    if (S && S.root === root) { schedule(); return; }
    // il Personalizza tema ricostruisce la sezione: la copia spostata nel body se ne va
    for (var i = 1; i < all.length; i++) if (all[i].parentNode) all[i].parentNode.removeChild(all[i]);
    if (S && S.root && S.root.parentNode && S.root !== root) S.root.parentNode.removeChild(S.root);
    var cfg = null;
    try { cfg = JSON.parse(root.getAttribute('data-hn-bb-cfg') || ''); } catch (e) { cfg = null; }
    if (!cfg || !cfg.pid) return;
    var keep = S || {};
    S = {
      root: root, cfg: cfg, pid: String(cfg.pid), visible: false, why: '', viewed: false,
      written: keep.written || 0, cartEl: null, watched: null, moBtn: keep.moBtn || null,
      img: q('[data-hn-bb-img]', root), name: q('[data-hn-bb-name]', root), lab: q('[data-hn-bb-var]', root),
      now: q('[data-hn-bb-now]', root), was: q('[data-hn-bb-was]', root), add: q('[data-hn-bb-add]', root),
      label: q('[data-hn-bb-label]', root), back: q('[data-hn-bb-back]', root)
    };
    // nel body: la colonna del prodotto è un contesto di sovrapposizione (sticky, z 2)
    // e lì dentro la barra non salirebbe mai sopra il resto della pagina
    document.body.appendChild(root);
    root.hidden = false;
    var D = window.HN_CART_DATA;
    var short = D && D.p && D.p[S.pid] && D.p[S.pid].n;
    if (short) S.name.textContent = short;
    S.add.addEventListener('click', onAdd);
    S.back.addEventListener('click', onBack);
    find();
    watchCart();
    var qv = q('.hn-pdp-qv');
    if (qv) watchQv(qv);
    sync();
    evaluate();
  }

  function boot() {
    mount();
    if (!S) return;
    addEventListener('scroll', schedule, { passive: true });
    addEventListener('resize', schedule, { passive: true });
    addEventListener('orientationchange', schedule);
    addEventListener('load', schedule);
    addEventListener('pageshow', function () { if (S) { S.awaiting = false; endPending(); sync(); } schedule(); });
    if (window.ResizeObserver) new ResizeObserver(schedule).observe(document.body);
    new MutationObserver(onBody).observe(document.body, { attributes: true, attributeFilter: ['class', 'style'], childList: true });
    // la variante: il tema rimanda `change` dall'input nascosto, i tondini cliccano il radio
    document.addEventListener('change', function () {
      clearTimeout(chT);
      chT = setTimeout(function () { sync(); schedule(); }, 60);
    }, true);
    document.addEventListener('hn:cart:changed', function () { if (S) success(); schedule(); });
    document.addEventListener('hn:bys:change', function () { if (S) sync(); schedule(); });
    document.addEventListener('hn:cart:ready', function () { if (S) watchCart(); schedule(); });
    document.addEventListener('DOMContentLoaded', function () { if (S) { watchCart(); sync(); } schedule(); });
    document.addEventListener('shopify:section:load', function () { mount(); });
  }

  if (window.__HN_BUYBAR_LOADED__) return;
  window.__HN_BUYBAR_LOADED__ = true;
  boot();
  window.HNBuybar = {
    why: function () { return S ? S.why : 'assente'; },
    evaluate: function () { evaluate(); },
    sync: function () { sync(); },
    _t: { state: function () { return S; } }
  };
})();
